import './App.css';
import { useEffect, useState } from 'react';
import { createHashRouter, RouterProvider } from 'react-router-dom';
import ProtectedRoute from "./Components/ProtectedRoute/ProtectedRoute";
import Layout from './Components/Layout/Layout';
import About from './Components/About/About';
import Education from './Components/Education/Education';
import Work from './Components/Work/Work';
// import BeyondWork from './Components/BeyondWork/BeyondWork';
import ProjectsGrid from './Components/ProjectsGrid/ProjectsGrid';
import MyCourse from './Components/MyCourse/MyCourse';
import ShopifyEdge from './Components/ShopifyEdge/ShopifyEdge';
import NotFound from './Components/NotFound/NotFound';
import { Toaster } from 'react-hot-toast';



function App() {
  const [isLoading, setIsLoading] = useState(() => {
    return sessionStorage.getItem('portfolioLoaded') !== 'true';
  });

  useEffect(() => {
    if (!isLoading) return;

    const timer = setTimeout(() => {
      sessionStorage.setItem('portfolioLoaded', 'true');
      setIsLoading(false);
    }, 1800);

    return () => clearTimeout(timer);
  }, [isLoading]);

   let routers = createHashRouter([
      {
        path: '', element: <Layout />, children: [
          { path: '/', element: <ProtectedRoute><About /></ProtectedRoute> },
          { path: 'Education', element: <ProtectedRoute><Education /></ProtectedRoute> },
          { path: 'Work', element: <ProtectedRoute><Work /></ProtectedRoute>},
          { path: 'ProjectsGrid', element: <ProtectedRoute><ProjectsGrid /></ProtectedRoute>},
          { path: 'MyCourse', element: <ProtectedRoute><MyCourse /></ProtectedRoute>},
          { path: 'ShopifyEdge', element: <ProtectedRoute><ShopifyEdge /></ProtectedRoute>},
          { path: "*", element: <NotFound /> },
        ]
      }
    ])

  return (
    <div className="App">
      {isLoading && (
        <div className="loading-screen" role="status" aria-live="polite">
          <div className="loading-core">
            <div className="loading-spinner"></div>
            <p>Initializing Portfolio</p>
            <div className="loading-bar">
              <span></span>
            </div>
          </div>
        </div>
      )}
      <Toaster />
      <RouterProvider router={routers} />
    </div>
  );
}

export default App;
